export default __webpack_public_path__ + "static/media/logo.a0a66857.png";